module.exports = __webpack_public_path__ + "fonts/IndivisibleWebBold.80cdf5b2.woff2";